<template>
  <div class="rechargeInfo">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">记录详情</span>
    </div>
    <div class="content">
      <div class="top">
        <div :class="info.rechargeStatus === 'UNRECHARGED' ? 'moneyIconFail' : 'moneyIcon'">￥</div>
        <div class="rechargeName">消费充值</div>
        <div :class="info.rechargeStatus === 'UNRECHARGED' ? 'rechargeFeeFail' : 'rechargeFee'">+{{ info.rechargeFee }}</div>
      </div>
      <div class="bottom">
        <div v-for="(item, index) in list" :key="index" class="item">
          <div class="name">{{ item.name }}：</div>
          <div class="value">{{ item.value || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { rechargeInfo } from '@/api/user';

export default {
  name: 'RechargeInfo',
  data() {
    return {
      info: {},
      list: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'expensesRecord' });
    },
    getInfo() {
      rechargeInfo({ id: this.$route.query.id }).then(res => {
        this.info = res.data;
        this.list = [
          { name: '当前状态', value: res.data.rechargeStatusName },
          { name: '商品名称', value: '消费充值' },
          { name: '充值方式', value: res.data.rechargeTypeName },
          { name: '充值时间', value: res.data.createTime },
          { name: '交易单号', value: res.data.rechargeSerial },
          { name: '商户单号', value: res.data.extraRechargeSerial }
        ];
      });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
  .rechargeInfo {
    .content {
      display: flex;
      flex-direction: column;

      .top {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 100%;
        .change_val(padding-top, 58);
        .change_val(padding-bottom, 28);
        .moneyIcon {
          .change_val(width, 102);
          .change_val(height, 102);
          .change_val(font-size, 48);
          background: #32CD32;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;
        }
        .moneyIconFail {
          .change_val(width, 102);
          .change_val(height, 102);
          .change_val(font-size, 48);
          background: #FF8E3B;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;
        }

        .rechargeName {
          .change_val(margin-top, 28);
          .change_val(font-size, 28);
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
        }

        .rechargeFee {
          .change_val(font-size, 36);
          .change_val(margin-top, 17);
          font-weight: 600;
          color: #32CD32;
        }

        .rechargeFeeFail {
          .change_val(font-size, 36);
          .change_val(margin-top, 17);
          font-weight: 600;
          color: #FF8E3B;
        }
      }

      .bottom {
        background: #FFFFFF;
        border: 1px solid #EFEFF4;
        box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
        opacity: 1;
        border-radius: 6px;
        .change_margin(margin, 0, 28);
        .change_margin(padding, 33, 42);

        .item {
          display: flex;
          .change_val(font-size, 28);
          .change_val(line-height, 60);
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          opacity: 1;
          .name {

          }
          .value {

          }
        }
      }
    }
  }
</style>
